"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7382],{

/***/ 77382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WhyChooseCS_PageContents; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Elements/index.js + 6 modules
var Elements = __webpack_require__(41551);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/Contents/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 22px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 22px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ';\n  font-family: "OpenSans SemiBold";\n\n  @media only screen and (max-width: 560px) {\n    font-size: 15px;\n  }\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  span.highlight {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31add2e5-0"
})(_templateObject());
var ContentWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31add2e5-1"
})(_templateObject1());
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31add2e5-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.textStyles.content2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.prune;
});
var CustomTextM = (0,styled_components_browser_esm/* default */.ZP)(Elements/* TextM */.Ei).withConfig({
    componentId: "sc-31add2e5-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.prune;
});

;// CONCATENATED MODULE: ./containers/WhyChooseCS/_page.js
var template = {
    pageTitle: "Why Choose Classy Closets",
    contents: {
        dynamicContents: [
            {
                id: 1,
                title: "THE COMPANY",
                subContents: "For over 35 years Classy Closets has been creating custom home storage solutions that are both beautiful and functional. You shouldn’t have to choose between one or the other, so we’ve adopted a belief that you don’t! Whether you are in search of the perfect walk-in closet, kitchen, home office or garage at Classy Closets, we do it all!"
            },
            {
                id: 2,
                title: "THE CLASSY DIFFERENCE",
                subContents: "Each custom closet design is created specifically for your space, your home, and your life. After scheduling your free in-home consultation with Classy Closets, one of our professional designers will meet with you and discuss your wants and needs. They will assess your space and discuss our many design options with you. You can choose from a selection of materials, colors, styles, finishes, and hardware. At Classy Closets the possibilities are truly endless!"
            },
            {
                id: 2,
                title: "PROFESSIONAL DESIGNERS",
                subContents: "Each of our custom home interior projects is expertly designed and crafted to help your life run a little smoother. Whether it’s finding things in the same place every time you look for it, enjoying the beauty of your home a little more or keeping you organized, we find joy in making you happy. We look forward to meeting with you and designing the storage solution of your dreams!"
            },
            {
                id: 2,
                title: "UNCOMPROMISING QUALITY",
                subContents: "Quality: Each of our designs is created using high-quality materials and hardware. Whether you choose to execute your project in solid wood or laminate, you can be assured that you are receiving the best for your home.<br/>Proper Fit: Your home is unique and your storage solution needs to be as well – a Classy Closets storage solution isn’t one size fits all. We make sure your built-in project fits tightly where it should, and that the right accessories and hardware are used to make it a perfect fit."
            },
            {
                id: 2,
                title: "EXPANSIVE SELECTION",
                subContents: "Custom Designs: Choose from a selection of materials, finishes, designs, and accessories. Solutions That Last: We don’t design storage solutions that will wear out in a few years. When you invest in Classy Closets, you can be sure that your storage solution will stand the test of time."
            },
            {
                id: 2,
                title: "UNPARALLELED SERVICE",
                subContents: "At Classy Closets, our biggest priority is you. We want to make sure that you’re happy with your custom storage solution. Once you schedule a free in-home consultation with one of our professional designers, you’re sure to see the Classy Closets difference.<br/><br/>We want to make sure that you’re happy with your custom storage solution."
            }, 
        ],
        staticContents: {
            title: "We Design, Layout, and install Commercial Office Workspaces.",
            contents: "We have design ideas for any commercial property. Our professional design team can provide custom design option for your commercial real estate project. From Federal, State or Private commercial office buildings, Restaurants, etc. We’ll generate ideas for the perfect layout that improves the productivity of your workspace or office. Our team of experts will layout a floor plan for the complete commercial office planning; from the private areas, shared spaces, meeting areas, and even the individual desks. We’ll even give you ideas for adding accessories that will enhance the functionality of your commercial office and workspaces.<br/><br/>Classy Closets also provides custom storage solutions for every commercial office. If your workspace needs a facelift, is failing to inspire, or even if you’re building a new office; Classy Closets professional designers can create the perfect workspace for your company. Each unique company and commercial office will need different layouts, materials, and accessories, and at Classy Closets everything we do is custom. Consider these options for your commercial office space:<br/><br/><span class='highlight'>Custom Work Space Layout:</span> We’ll provide you with office space designs for the perfect workspace flow; From where you want your desks or even the printer. Everything designed and laid out to meet your preferences.<br/> <span class='highlight'>Custom Desk Space:</span> Whether you’re in need of an oversized desk with lots of storage or multiple small cubbies, each of our desks has a custom space and custom design.<br/><span class='highlight'>Work Space Accessories:</span> Need built-in printer storage or a pull-out wastebasket? No matter your workspace accessory needs, Classy Closets has you covered.<br/><br/> We look forward to working with you and creating your new custom commercial office. Schedule an appointment with one of our professional designers today!"
        }
    }
};

;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/Contents/index.js





var Contents = function() {
    var contents = template.contents;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            contents.dynamicContents.map(function(content, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* TitleM */.ek, {
                            talign: "left",
                            children: content.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* TextM */.Ei, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: content.subContents
                                }
                            })
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                        children: contents.staticContents.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTextM, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: contents.staticContents.contents
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageContents_Contents = (Contents);

// EXTERNAL MODULE: ../../node_modules/antd/es/row/index.js
var row = __webpack_require__(3306);
// EXTERNAL MODULE: ../../node_modules/antd/es/col/index.js
var col = __webpack_require__(3086);
// EXTERNAL MODULE: ./components/Cards/index.js + 8 modules
var Cards = __webpack_require__(642);
;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/CardSection/styled.js

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 0;\n\n  @media only screen and (max-width: 560px) {\n    margin-bottom: 26px;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7a94eb00-0"
})(styled_templateObject());
var CustomCard = (0,styled_components_browser_esm/* default */.ZP)(Cards/* ServiceCard */.WF).withConfig({
    componentId: "sc-7a94eb00-1"
})(styled_templateObject1());

;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/CardSection/_cards.js
var cards = [
    {
        id: 1,
        type: "blog",
        title: "OUR PRODUCTS",
        imgSrc: "/images/why_choose_classy_closets/our-products.png",
        contentTitle: "",
        content: "",
        btnText: "View All",
        href: "/view-all-products"
    },
    // {
    //   id: 2,
    //   type: "blog",
    //   title: "ON THE BLOG",
    //   imgSrc: "/images/home_page/custom_homeoffice.jpg",
    //   contentTitle: "",
    //   content: "",
    //   btnText: "View Blog",
    //   href: "/blog"
    // },
    {
        id: 3,
        type: "blog",
        title: "OUR STORY",
        imgSrc: "/images/why_choose_classy_closets/our_story.png",
        contentTitle: "",
        content: "",
        btnText: "About Us"
    }, 
];

;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/CardSection/index.js





var CardSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
            justify: "center",
            gutter: {
                xs: 0,
                sm: 32,
                md: 24,
                lg: 24
            },
            children: cards.map(function(card, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    xs: 14,
                    sm: 11,
                    md: 10,
                    lg: 9,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCard, {
                        type: card.type,
                        title: card.title,
                        imgSrc: card.imgSrc,
                        content: card.content,
                        contentTitle: card.contentTitle,
                        btnText: card.btnText,
                        bptop: "20px",
                        url: card.href
                    })
                }, key);
            })
        })
    });
};
/* harmony default export */ var PageContents_CardSection = (CardSection);

;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/styled.js

function PageContents_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 35px;\n  padding-bottom: 60px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n\n  @media only screen and (max-width: 768px) {\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n  @media only screen and (max-width: 560px) {\n    padding-top: 33px;\n    padding-bottom: 41px;\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n"
    ]);
    PageContents_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PageContents_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c8ed6875-0"
})(PageContents_styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.mobile;
});

;// CONCATENATED MODULE: ./containers/WhyChooseCS/PageContents/index.js






var PageContents = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContents_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* TitleL */.lr, {
                talign: "left",
                children: "Why Choose Classy Closets"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContents_Contents, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContents_CardSection, {})
        ]
    });
};
/* harmony default export */ var WhyChooseCS_PageContents = (PageContents);


/***/ })

}]);